 <!-- 画廊模式 -->
<template>
  <div
    class="gallery-box animated"
    :class="{ 'fade-in': showAinmate, 'fade-out': !showAinmate }"
    v-if="galleryShow"
    @click.stop="handleClickBox"
  >
    <span class="gallery-page" :style="{ marginTop: `${marginTop}px` }">
      <!-- {{ `${index + 1}/${album.length}` }} -->
      {{``}}
    </span>
    <div class="gallery-body" id="scrollbody">
      <div class="gallery-album" ref="scrollimg" :style="`height:${innerHeight-200}px`">
        <!-- <div @click.stop="handleChangeImg" class="aaa">ddddd</div> -->
        <img
              class="gallery-img"
              :style="`height:${PicRatio>0?375/PicRatio:375}px`"
              :src="album[0]"
            />
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll';

export default {
  name: 'prefix-gallery',
  data: () => ({
    galleryShow: false,
    showAinmate: true,
    index: 0,
    marginTop: 20,
    albumChange: [],
    imgLoadError: false,
    innerHeight: 750,
  }),
  props: {
    /* album */
    album: {
      type: Array,
      default() {
        return [];
      },
    },
    /* 位置 */
    position: {
      type: Number,
      default: 0,
    },
    PicRatio: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    album: {
      handler: 'handleData',
      immediate: true,
    },
    // album() {
    // },
    // deep: true,
  },
  created() {
  },
  methods: {
    handleData() {
      this.albumChange = this.album.map((n) => ({
        url: n,
        loaded: false,
      }));
    },
    handleClickBox() {
      this.showAinmate = false;
      setTimeout(() => {
        // 如果再500ms里面点击小图片，点击无效，setTimeout被调用两次,使用200ms，比动画时间短一点，
        this.galleryShow = false;
        document.getElementById('scrollbody').removeEventListener('touchmove', (event) => {
          event.preventDefault();
        });
      }, 200);
    },
    showGallery() {
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      this.innerHeight = systemInfo.screenHeight / systemInfo.pixelRatio;
      // #endif
      // this.innerHeight = window.windowHeight;
      this.index = this.album.length > this.position ? this.position : 0;
      this.galleryShow = true;
      this.showAinmate = true;
      this.$nextTick(() => {
        document.getElementById('scrollbody').addEventListener('touchmove', (event) => {
          event.preventDefault();
        });
        // eslint-disable-next-line no-unused-vars
        const scroll = new BScroll(this.$refs.scrollimg, {
          scrollY: true,
          click: true,
        });
      });
    },
    handleChangeImg() {
      // const { detail: { current } } = event;
      this.index = 1;
      this.imgLoadError = false;
    },
    handleLoaded(idx) {
      this.albumChange[idx].loaded = true;
    },
    handleError() {
      this.imgLoadError = true;
    },
  },
};
</script>

<style lang="less" scoped>
.gallery-box {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);

  display: flex;
  flex-direction: column;
}
.aaa{
  color: #fff;
}
.gallery-page {
  color: #fff;
  font-size: 36px;
  text-align: center;
  padding-bottom: 20px;
}
.gallery-body {
  flex: 1;
}
.gallery-album {
  height: 1000px;
}
.album-item {
  width: 750px;
  height: 100%;
  position: relative;
}
.gallery-img {
  width: 750px;
}
.img-tips {
  color: #fff;
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  text-align: center;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
.fade-in {
  animation-name: fadeIn;
}
.fade-out {
  animation-name: fadeOut;
}
.animated {
  animation-duration: 500ms;
  animation-fill-mode: both;
}
</style>
